import { grey } from '@material-ui/core/colors';
import { POINTER_GREEN } from './../utils/const';

// PRIMARY THEME COLORS
export const COLOR_PRIMARY_1 = '#3AAFA9';
export const COLOR_PRIMARY_2 = '#037A90';
export const SUBSCRIPTION_MODAL_DARK_THEME_COLOR = '#093137';

export const COLOR_PRIMARY_1_100 = '#D8EFEE';
export const COLOR_PRIMARY_1_200 = '#C4E7E5';
export const COLOR_PRIMARY_1_300 = '#B0DFDD';
export const COLOR_PRIMARY_1_400 = '#9DD7D4';
export const COLOR_PRIMARY_1_500 = '#89CFCB';
export const COLOR_PRIMARY_1_600 = '#75C7C3';
export const COLOR_PRIMARY_1_700 = '#61BFBA';
export const COLOR_PRIMARY_1_800 = '#4EB7B2';

export const COLOR_PRIMARY_2_100 = '#CDE4E9';
export const COLOR_PRIMARY_2_200 = '#B3D7DE';
export const COLOR_PRIMARY_2_300 = '#9ACAD3';
export const COLOR_PRIMARY_2_400 = '#81BDC8';
export const COLOR_PRIMARY_2_500 = '#68AFBC';
export const COLOR_PRIMARY_2_600 = '#4FA2B1';
export const COLOR_PRIMARY_2_700 = '#3595A6';
export const COLOR_PRIMARY_2_800 = '#1C879B';

/** Teal used in Market Intelligence charts (Booking Pattern, Calendar, Guests Analysis). */
export const CHART_TEAL = '#0097B2';

// SECONDARY THEME COLORS
export const COLOR_SECONDARY_1 = '#FF2079';
export const COLOR_SECONDARY_2 = '#FF5F01';

export const COLOR_SECONDARY_1_100 = '#FFD2E4';
export const COLOR_SECONDARY_1_200 = '#FFBCD7';
export const COLOR_SECONDARY_1_300 = '#FFA6C9';
export const COLOR_SECONDARY_1_400 = '#FF90BC';
export const COLOR_SECONDARY_1_500 = '#FF79AF';
export const COLOR_SECONDARY_1_600 = '#FF63A1';
export const COLOR_SECONDARY_1_700 = '#FF4D94';
export const COLOR_SECONDARY_1_800 = '#FF3686';

export const COLOR_SECONDARY_2_100 = '#FFDFCC';
export const COLOR_SECONDARY_2_200 = '#FFCFB3';
export const COLOR_SECONDARY_2_300 = '#FFBF99';
export const COLOR_SECONDARY_2_400 = '#FFAF80';
export const COLOR_SECONDARY_2_500 = '#FF9F67';
export const COLOR_SECONDARY_2_600 = '#FF8F4D';
export const COLOR_SECONDARY_2_700 = '#FF7F34';
export const COLOR_SECONDARY_2_800 = '#FF6F1A';

// TERTIARY THEME COLOR
export const COLOR_TERTIARY_1 = '#286393';

export const COLOR_TERTIARY_1_100 = '#8EC9F9';
export const COLOR_TERTIARY_1_200 = '#7BC0F8';
export const COLOR_TERTIARY_1_300 = '#68B7F7';
export const COLOR_TERTIARY_1_400 = '#55AEF6';
export const COLOR_TERTIARY_1_500 = '#42A5F5';
export const COLOR_TERTIARY_1_600 = '#3B95DD';
export const COLOR_TERTIARY_1_700 = '#3584C4';
export const COLOR_TERTIARY_1_800 = '#2E73AC';

export const GRAPH_BLUE = '#7a8fef';

// BACKGROUND COLORS
export const COLOR_BACKGROUND_1 = '#F3FAFB';
export const COLOR_BACKGROUND_2 = '#FFFFFF';

// PROMPT COLORS
export const COLOR_SUCCESS = '#00CC00';
export const COLOR_SUCCESS_1 = 'rgb(53, 123, 56)';
export const COLOR_SUCCESS_1_HOVER = 'rgba(53, 123, 56, .7)';
export const COLOR_SUCCESS_BACKGROUNG = 'rgb(241, 249, 241)';
export const COLOR_ERROR = '#CC0000';
export const COLOR_ERROR_1 = 'rgb(171, 47, 38)';
export const COLOR_ERROR_1_HOVER = 'rgba(171, 47, 38,.7)';
export const COLOR_ERROR_BACKGROUNG = 'rgb(254, 240, 239)';
export const COLOR_WARNING = '#FFA500';
export const COLOR_INFO = '#42A5F5';

// TEXT COLORS
export const COLOR_TEXT_1 = '#000000';
export const COLOR_TEXT_2 = '#292B3D';
export const COLOR_TEXT_3 = '#AEAEAE';
export const COLOR_TEXT_4 = '#36454F';

// OTHER COLORS
export const COLOR_GREY_200 = grey[200];
export const COLOR_GREY_400 = grey[400];
export const COLOR_GREY_600 = grey[600];
export const COLOR_GREY_800 = '#e0e0e0';

// TEXT COLORS
export const COLOR_TEXT_GREY = '#8B92A5';

// HISTORICAL COLOR GRADIENT
export const HISTORICAL_COLORS_GRADIENT = ['#fd5c63', '#E32636', '#9e1b32', '#AA0000'];
export const HISTORICAL_COLORS_GRADIENT_REVENUE = [
  COLOR_PRIMARY_2_200,
  COLOR_PRIMARY_2_400,
  COLOR_PRIMARY_2_600,
  COLOR_PRIMARY_2_800,
];

// BarGraphColor
export const HISTORICAL_BARGRAPH_COLOR = '#F0F2F8';
export const LISTING_COUNT_BAR_GRAPH_COLOR = COLOR_SECONDARY_2_600;

// Button Color
export const SIMULATOR_ASSISTANT_BUTTON = '#BF40BF';
export const SIMULATOR_ASSISTANT_BUTTON_HOVER = '#f075f0';
export const SAVE_TO_ANALYSIS_BUTTON = '#6f7082';
export const SAVE_TO_ANALYSIS_BUTTON_HOVER = '#80808c';
export const CLOSE_BUTTON_UNHIGHLIGHTED = '#757575';

export const WATER_MARK_COLOR = '#551A8B';
export const COLOR_AIRBTICS_PRO_CTA_BUTTON = '#070026';

export const RED_BUTTON_COLOR = '#e92a2a';
export const RED_BUTTON_COLOR_HOVER = '#ec5959';

// dark theme
export const BACKGROUND_COLOR_1 = '#121212';
export const BACKGROUND_COLOR_2 = '#1E1E1E';

// neighbourhood theme
export const NEIGHBOURHOOD_THEME = ['#f7f8f8', '#fbe0eb', '#f08bb4', '#eb3f79', '#c9341e'];

// main card
export const REVENUE_MAIN_CARD_COLOR = '#64CCB8';
export const DAILY_RATE_MAIN_CARD_COLOR = '#FF5F01';
export const No_OF_LISTINGS_MAIN_CARD_COLOR = '#5CA5EF';
export const KPI_CARD_COLOR = COLOR_PRIMARY_2;
export const DEFAULT_TEXT_COLOR = COLOR_TEXT_4;
export const SIDEBAR_COLOR = '#FFFFFF';
export const LIGHT_COMPARE_BACKGROUND_COLOR = 'rgba(217, 217, 217, 0.16)';

export const SUBSCRIPTION_MODAL_LIGHT_BACKGROUND_COLOR = '#F1F5F6';
export const SUBSCRIPTION_MODAL_DISCOUNT_BACKGROUND_COLOR = '#D8EFC5';
export const SUBSCRIPTION_MODAL_DISCOUNT_TEXT_COLOR = '#559F1A';

export const DISCOVERY_LIGHT_BACKGROUND_COLOR = '#F7F7F7';

export const BAR_LESS_THAN_20_PERCENT = '#FF4942';
export const BAR_LESS_THAN_70_PERCENT = '#FFC824';
export const BAR_MORE_THAN_70_PERCENT = '#2ADE72';

export const INACTIVE_MARKER_COLOR = 'rgba(128, 128, 128, 0.5)';

export const INFO_BUTTON_COLOR = '#4aa59a';

export const MAP_FILL_COLOR = POINTER_GREEN;

export const BOOKING_DATA_AREA_CHART_COLOR = [
  REVENUE_MAIN_CARD_COLOR,
  DAILY_RATE_MAIN_CARD_COLOR,
  No_OF_LISTINGS_MAIN_CARD_COLOR,
];

export const API_CREDITS_PAGE_GREEN_COLOR = '#4CAF50';
